import reports from './domains/reports';
import dashboard from './domains/dashboard';
import food from './domains/food';
import labor from './domains/labor';
import cash from './domains/cash';
import service from './domains/service';
import people from './domains/people';
import commsHub from './domains/commsHub';
import product from './domains/product';

const domains = [reports, dashboard, food, labor, cash, service, people, commsHub, product];

const merged = { en: {}, es: {} };

for (const domain of domains) {
  Object.assign(merged.en, domain.en);
  Object.assign(merged.es, domain.es);
}

export default merged;
